
import { Payload } from "@/types/profile";

export const generalPayloads: Payload[] = [
  // Notifications payloads
  {
    id: "notifications",
    name: "Notifications",
    description: "Configure notification settings",
    category: "General",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "allowNotifications",
        name: "Allow Notifications",
        type: "boolean",
        required: true,
        default: true,
        description: "Allow notifications on the device"
      },
      {
        id: "showInLockScreen",
        name: "Show in Lock Screen",
        type: "boolean",
        required: false,
        default: true,
        description: "Allow notifications to be shown on the lock screen"
      }
    ]
  },
  
  // Software Update payloads
  {
    id: "softwareUpdate",
    name: "Software Update",
    description: "Configure software update settings",
    category: "General",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "autoCheck",
        name: "Automatically Check for Updates",
        type: "boolean",
        required: true,
        default: true,
        description: "Automatically check for software updates"
      },
      {
        id: "autoDownload",
        name: "Automatically Download Updates",
        type: "boolean",
        required: false,
        default: false,
        description: "Automatically download software updates"
      },
      {
        id: "criticalUpdateInstall",
        name: "Install Critical Updates",
        type: "boolean",
        required: false,
        default: true,
        description: "Automatically install critical security updates"
      }
    ]
  }
];
